import { render, staticRenderFns } from "./VaFileUpload.demo.vue?vue&type=template&id=1ebcf2e0&"
import script from "./VaFileUpload.demo.vue?vue&type=script&lang=js&"
export * from "./VaFileUpload.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports